import { render, staticRenderFns } from "./SectionContact.vue?vue&type=template&id=98de0cd6&scoped=true"
import script from "./SectionContact.vue?vue&type=script&lang=js"
export * from "./SectionContact.vue?vue&type=script&lang=js"
import style0 from "./SectionContact.vue?vue&type=style&index=0&id=98de0cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98de0cd6",
  null
  
)

export default component.exports